import React from 'react';
import './modal.css';

export const Modal = ({handleClose, show, children}) => {
  const showHideClassName = show ? "modal display-block" : "modal display-none";

  return (
    <div className={showHideClassName}>
      <section className="modal-main">
        <button
          className="float-right bg-transparent hover:bg-red-400 border-red-400 text-red-400 font-semibold
           hover:text-white py-2 px-4 border hover:border-transparent rounded m-1"
          type="button" onClick={handleClose}>
          X Close window
        </button>
        {children}
      </section>
    </div>
  );
};
